// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"967c38c2","516":"dc127a34","821":"bdf51f54"}[chunkId] + ".chunk.css";
};